
import React from 'react';

const SidebarElementWrapper = (props) => (
	<div className="element-wrapper">{props.children}</div>
);

export default SidebarElementWrapper;


// WEBPACK FOOTER //
// ./components/builder/SidebarElementWrapper.js